import './LoadingPage.css'

import { Spinner } from '@shopify/polaris'

const LoadingPage = () => (
  <div className='loading-indicator__wrapper'>
    <Spinner accessibilityLabel='Loading application' size='large' />
  </div>
)

export default LoadingPage
